import { Button, Field, TextField, Autocomplete, DatePicker } from "components/commons";
import { InputAmount, SelectShiftsPaginated } from "components/field";
import styles from "./key-account-form.module.scss";
import { useFormContext } from "contexts/form-context";
import { FormMode } from "enums";
import locale from "localization";
import { useMemo } from "react";
import { ShiftStatus } from "enums";
import moment from "moment";
import TimePickerV2 from "components/commons/time-picker/time-picker-v2";
import { paymentMethod } from "data/constant/key-account-payment-methods";
import SelectKeyAccount from "./select-key-account";

const KeyAccountForm = ({ loading }) => {
  const { formMode, fields, modifyField, isFormSubmittable } = useFormContext();
  const isAdd = formMode === FormMode.Add;

  const isDateToday = useMemo(
    () => moment(fields.date.value).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD"),
    [fields.date.value],
  );

  return (
    <div className={styles.form}>
      <div className={styles.dateRow}>
        <Field {...fields.date} label={locale.date} childrenClassName={styles.fieldContent}>
          <DatePicker
            {...fields.date}
            prettify={(date) => moment(date).format("YYYY-MM-DD HH:mm")}
            onChange={modifyField}
            Component={DatePicker}
            disableEndDate={new Date()}
          />
        </Field>
        <Field {...fields.time} label={locale.time} childrenClassName={styles.fieldContent}>
          <TimePickerV2
            {...fields.time}
            variant={"purple"}
            onChange={modifyField}
            Component={TimePickerV2}
            maxTime={isDateToday ? new Date() : undefined}
            date={fields.date.value}
          />
        </Field>
      </div>
      <Field {...fields.shiftId} label={locale.shift} childrenClassName={styles.shiftField}>
        <SelectShiftsPaginated
          {...fields.shiftId}
          disableAllOption
          shiftStatus={[ShiftStatus.Started, ShiftStatus.Ended]}
          onChange={modifyField}
          placeholder={locale.selectShift}
          isHideBankDeposit={false}
        />
      </Field>
      <Field
        {...fields.amount}
        label={locale.amount}
        message={<locale.Populate items={["13"]} text={locale.maximumDigitsAndDecimalPlaces} />}
        style={{
          width: "250px",
        }}
      >
        <InputAmount {...fields.amount} onChange={modifyField} Component={InputAmount} />
      </Field>
      <Field {...fields.remarks} label={locale.remarks}>
        <TextField multiline {...fields?.remarks} onChange={modifyField} />
      </Field>

      <Field {...fields.siNumber} childrenClassName={styles.fieldContent}>
        <TextField {...fields.siNumber} onChange={modifyField} />
      </Field>

      <Field {...fields.keyAccountId} childrenClassName={styles.fieldContent}>
        <SelectKeyAccount {...fields.keyAccountId} onChange={modifyField} />
      </Field>

      <Field
        {...fields.paymentMethod}
        label={locale.paymentMethod}
        childrenClassName={styles.fieldContent}
      >
        <Autocomplete
          {...fields.paymentMethod}
          onChange={modifyField}
          options={paymentMethod}
          Component={Autocomplete}
        />
      </Field>

      <Field {...fields.referenceNumber} childrenClassName={styles.fieldContent}>
        <TextField {...fields.referenceNumber} onChange={modifyField} />
      </Field>

      <div style={{ display: "flex", gap: "1em" }}>
        {isAdd && (
          <Button type="submit" primary disabled={!isFormSubmittable || loading} loading={loading}>
            {locale.submit}
          </Button>
        )}
      </div>
    </div>
  );
};

export default KeyAccountForm;
